export default class ResettableTimeout {
    constructor(handler, initialTimeout, precision = 1000) {
        this.initialTimeout = initialTimeout
        this.handler = handler
        this.remainingTime = initialTimeout
        this.interval = undefined
        this.precision = precision
    }
    start() {
        this.interval = setInterval(() => {
            this.remainingTime -= this.precision
            if (this.remainingTime <= 0) {
                this.flush()
            }
        }, this.precision)
    }
    reset() {
        this.remainingTime = this.initialTimeout
    }
    clear() {
        clearInterval(this.interval)
    }
    flush() {
        this.clear()
        this.handler.call()
    }
}
